module.exports = __webpack_public_path__ + "img/o.dce9de3e.jpg";